import { Upload } from "antd";
// import ImgCrop from "antd-img-crop";
import { useContext, useEffect, useState } from "react";
// import { useDispatch } from "react-redux";
// import { addBackgroundImage } from "../../Redux/Actions/CardAction";
// import { CardContext } from "../../store/CardContext";


const App = () => {
  // const { backgroundImage } = useSelector((state) => state.cardReducer);
  // const dispatch = useDispatch();
  // const [fileList, setFileList] = useState(
  //   backgroundImage[0]?.thumbUrl
  //     ? [
  //         {
  //           uid: "-1",
  //           name: "image.png",
  //           status: backgroundImage[0]?.thumbUrl ? "done" : "",
  //           url: backgroundImage[0]?.thumbUrl,
  //         },
  //       ]
  //     : []
  // );

  const [fileList, setFileList] = useState([])
  // const [userData, setUserData] = useContext(CardContext)
  

  // useEffect(() => {
  //   setFileList(
  //     userData.backgroundImage
  //     ? [
  //         {
  //           uid: "-1",
  //           name: "image.png",
  //           status:  userData.backgroundImage ? "done" : "",
  //           url:  userData.backgroundImage,
  //         },
  //       ]
  //     : []
  //   )
  // }, [userData])

  const onChange = ({ fileList: newFileList }) => {
    if(newFileList[0]?.status){newFileList[0].status="done";}
    setFileList(newFileList);

    // dispatch(addBackgroundImage(fileList));
  };

  const onPreview = async (file) => {
    let src = file.url;
    if (!src) {
      src = await new Promise((resolve) => {
        const reader = new FileReader();
        reader.readAsDataURL(file.originFileObj);
        reader.onload = () => resolve(reader.result);
      });
    }
    const image = new Image();
    image.src = src;
    const imgWindow = window.open(src);
    imgWindow?.document.write(image.outerHTML);
  };
  return (
    <div>
      {/* <ImgCrop aspect={16 / 9} aspectSlider showReset> */}
        <Upload
          action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
          listType="picture-card"
          fileList={fileList}
          onChange={onChange}
          onPreview={onPreview}
        >
          {fileList.length < 1 && "+ Upload"}
        </Upload>
      {/* </ImgCrop> */}
    </div>
  );
};
export default App;
